module.exports = __webpack_public_path__ + "static/img/1_1_3.d65bf2f8.jpg";